// ── Suppression COHÉRENTE d'un BROUILLON — logique pure ──
// CHEMIN ARGENT. Extrait de `deleteFactureCoherent` (App.jsx, Pass A).
//
// RÈGLE (Dimitri, noyau 3 ; CGI 289) : une facture ÉMISE (qui porte un
// numéro) ne s'efface JAMAIS — on l'annule par un AVOIR. Seul un BROUILLON
// (sans numéro) se supprime. Ce flow refuse donc toute entrée numérotée SANS
// appeler le serveur ni toucher au KV ; le serveur refuse de son côté
// (peutSupprimerFacture, lib/invoice-handlers.js). Plus de case « transmise »
// ni de drapeau confirmDelivered : plus rien ne les demande.
//
// Source fiscale = table invoices (PAS le factLog KV). Brouillon : suppression
// en base D'ABORD (action serveur deleteInvoiceHard), PUIS purge du factLog KV.
// Refus serveur → message affiché, KV non purgé (cohérence DB↔KV).
//
// Entrée sans invoiceId ET sans numéro : purge KV seule (aucune ligne en base).
//
// 🔴 Chantier D2 — DÉ-POSITIONNALISATION : on purge par IDENTITÉ (`invoiceId`,
// sinon fallback `num` puis référence d'objet pour les entrées legacy), via un
// updater functional passé à saveLog (`prev => prev.filter(...)`) — robuste à
// tout réordonnancement du factLog entre la modale et la confirmation.
//
// Dépendances injectées :
//   - entry           : l'entrée ciblée (ou null/undefined si absente)
//   - callDeleteInvoice(invoiceId) → Promise<{ ok, message }> : appel serveur
//   - saveLog(updater) : persistance KV — reçoit un updater functional `prev => next`
//   - onError(message): affichage d'erreur (alert)
//   - done()          : finalisation UI (setConfirm(null)) — toujours appelé
//
// Garantie : ordre serveur-AVANT-KV ; en cas de refus (local ou serveur) ou
// d'exception, `saveLog` n'est JAMAIS appelé (KV non purgé).

import { MESSAGE_FACTURE_EMISE } from "./facture-suppression"

// Updater pur retirant `entry` du factLog par identité stable (invoiceId), avec
// fallback legacy : `num` si présent, sinon référence d'objet stricte.
function makeRemoveUpdater(entry) {
  return (prev) => prev.filter(x => {
    if (entry.invoiceId) return x.invoiceId !== entry.invoiceId
    if (entry.num) return !(!x.invoiceId && x.num === entry.num)
    return x !== entry
  })
}

async function deleteFactureCoherent(entry, { callDeleteInvoice, saveLog, onError, done }) {
  if (!entry) { done(); return }

  // Pièce émise (numérotée, ligne en base ou entrée legacy du KV) : jamais.
  if (entry.invoice_number || entry.num) {
    onError(MESSAGE_FACTURE_EMISE)
    done()
    return
  }

  // Sans invoiceId (et sans numéro) → purge KV seule.
  if (!entry.invoiceId) {
    saveLog(makeRemoveUpdater(entry))
    done()
    return
  }

  // DB d'abord : suppression réelle gardée côté serveur.
  try {
    const res = await callDeleteInvoice(entry.invoiceId)
    if (!res.ok) {
      // 409 = pièce émise / annulée / avoir → NE PAS purger le KV.
      onError(res.message)
      done()
      return
    }
    // DB OK → purge KV ensuite (ordre DB-first préserve la cohérence).
    saveLog(makeRemoveUpdater(entry))
    done()
  } catch (e) {
    console.error('[deleteFactureCoherent] échec :', e)
    onError("Erreur lors de la suppression : " + (e?.message || JSON.stringify(e)))
    done()
  }
}

export { deleteFactureCoherent, makeRemoveUpdater }
